{
  "title": "Billing & Plan",
  "tabs": {
    "subscription": "Subscription",
    "invoices": "Invoices"
  },
  "plan": {
    "free": "Free",
    "plus": "Plus",
    "pro": "Pro"
  },
  "status": {
    "TRIALING": "Trial",
    "ACTIVE": "Active",
    "renewalStopped": "Renewal stopped"
  },
  "invoiceStatus": {
    "PENDING": "Awaiting payment",
    "PAID": "Paid",
    "EXPIRED": "Expired"
  },
  "planBadge": {
    "trial": "Trial"
  },
  "periodEnds": "Period ends {{date}}",
  "periodEndsCycle": "Period ends {{date}} · {{cycle}}",
  "cycleMonthlyShort": "billed monthly",
  "cycleAnnualShort": "billed annually",
  "nextInvoice": "On {{date}} LopHoc raises the next period's invoice for you to scan and pay — no card is ever charged automatically.",
  "autoRenewOff": "You keep using {{plan}} as normal until {{date}}. After that the account moves to the Free plan — your data stays exactly as it is, nothing is lost.",
  "stopRenewal": "Stop raising the next invoice",
  "trialEnds": "Trial until {{date}}",
  "freeNoExpiry": "Free plan — no expiry",
  "scheduledChange": "{{plan}} is paid for — starts {{date}}",
  "upgrade": {
    "title": "Upgrade your plan",
    "subtitle": "Compare plans to find the one that fits your needs.",
    "tiers": {
      "free": "Free",
      "plus": "Plus",
      "pro": "Pro",
      "center": "Center"
    },
    "price": {
      "free": "Free",
      "perMonth": "{{amount}}/mo",
      "perYear": "{{amount}}/yr",
      "annualPerMonth": "{{amount}}/mo",
      "annualNote": "save {{save}}/yr · billed {{total}}/yr"
    },
    "rows": {
      "students": "Students",
      "seats": "Teachers (seats)",
      "core": "Attendance, timetable, month close",
      "noWatermark": "No watermark on invoices",
      "qrPayment": "Receive payments via QR (VietQR)",
      "autoReconcile": "Auto-reconcile payments",
      "autoReconcileManual": "Manual",
      "aiCredits": "AI messages / month",
      "aiImport": "AI import",
      "sessionNotes": "Session notes and monthly reviews",
      "progressLink": "Parent progress link + homework photos",
      "bookkeeping": "Bookkeeping + extra sales",
      "zns": "Auto-send invoices over Zalo ZNS",
      "payroll": "Payroll split",
      "multiBranch": "Multiple centres / branches"
    },
    "currentPlan": "Current plan",
    "ctaChoose": "Choose",
    "cta": "Upgrade",
    "comingSoon": "Coming soon",
    "cycle": {
      "monthly": "Monthly",
      "annual": "Annual"
    },
    "annualSave": "Save 20%",
    "enterprise": {
      "body": "Over 500 auto-matched transfers a month, a chain of centres, whitelabel, or bringing AI into how your centre runs? ThinkSwarm — the team that built LopHoc alongside a real centre — delivers it directly.",
      "cta": "Message us on Zalo →"
    }
  },
  "choose": {
    "titleTrial": "Choose a plan to keep these features after your trial ends",
    "titleUpgrade": "Upgrade",
    "compare": "Compare all plans",
    "ctaChoose": "Choose {{plan}}",
    "ctaUpgrade": "Upgrade to {{plan}}",
    "annualSub": "save {{save}}/yr · billed {{total}}/yr",
    "perMonthSuffix": "/mo",
    "monthlySub": "billed monthly",
    "summary": {
      "PLUS": "Unlimited students · 2 teacher seats · 60 auto-matched transfers/month · AI import",
      "PRO": "Adds bookkeeping + extra sales, payroll, no watermark · 150 transfers/month · 2,000 AI credits",
      "CENTER": "20 teacher seats · 500 auto-matched transfers/month · 5,000 AI credits"
    }
  },
  "reassure": {
    "noAutoCharge": "No card is ever charged automatically. Each period LopHoc raises an invoice for you to scan and pay by QR.",
    "quotaSoft": "Running out of quota only stops the automatic work — your data stays intact and you can still record everything by hand.",
    "payEarly": "Paying early costs you nothing — the new period is added on top of what is left of this one."
  },
  "highestPlan": "You're on the highest plan",
  "unlimited": "Unlimited",
  "usage": {
    "studentsBar": "Students",
    "studentsUnlimitedValue": "unlimited",
    "studentsNearLimit": "One student place left. Plus and above are unlimited.",
    "aiCreditsBar": "AI credits this month",
    "reconcileBar": "Auto-matched transfers this month",
    "reconcileOff": "Your plan has no auto-matching — upgrade to have payments recorded for you.",
    "reconcileExhausted": "You've used this month's auto-match quota. Parents' transfers still reach your bank account as usual, but LopHoc has stopped recording them automatically — mark those invoices paid by hand. It reopens at the start of next month, or immediately if you upgrade.",
    "reconcileExhaustedCta": "Upgrade"
  },
  "resume": "Turn it on",
  "resumeLink": "Turn renewal back on",
  "invoicesEmpty": "No plan invoices yet",
  "invoicesEmptyHint": "Every time you buy a plan or renew, the invoice lands here with its transfer note and status. LopHoc never holds your card, so nothing is ever charged automatically.",
  "invoicePaidOn": "Paid {{date}}",
  "invoice": {
    "paymentInstructions": "Transfer using the following info to activate your plan",
    "scanQr": "Scan with your banking app",
    "ref": "Transfer note",
    "bank": "Bank",
    "accountNo": "Account No",
    "accountName": "Account name",
    "iPaid": "I've transferred",
    "iPaidHint": "Your plan activates automatically once the transfer arrives, usually within a minute or two. Keep the transfer note exactly as shown so that can happen.",
    "iPaidZaloCta": "Something wrong? Message LopHoc.app on Zalo",
    "copy": "Copy",
    "copied": "Copied",
    "expired": "This invoice has expired. Start a new upgrade from the Billing page.",
    "devMockPay": "Dev: Mock as paid",
    "devMockPayHint": "Only shown in test environments (dev/demo) — simulates payment to test the trial → paid flow while subscription invoices have no automatic reconciliation yet.",
    "devMockPayError": "Failed to simulate payment.",
    "paidTitle": "Payment received",
    "justPaidTitle": "Payment successful!",
    "paidAmount": "Amount",
    "paidAt": "Received at",
    "paidPeriod": "Active until",
    "backToBilling": "Back to Billing",
    "waiting": "Waiting for your transfer…",
    "recheck": "Check again",
    "stoppedWatching": "Stopped checking automatically after 10 minutes.",
    "orderTitle": "Order",
    "planLabel": "Plan",
    "cycleLabel": "Billing cycle",
    "periodLabel": "Period",
    "totalLabel": "Total",
    "payTitle": "Scan to pay",
    "cycleMonthly": "Monthly",
    "cycleAnnual": "Annual",
    "breakdown": {
      "title": "How this amount is worked out",
      "sameCycleLine": "This is the difference between {{fromPlan}} and {{toPlan}} for the {{days}} days left in your current period — you are not buying the term again.",
      "sameCycleRate": "Charged at {{diff}} per {{cycleDays}} days, rounded down to the nearest thousand.",
      "sameCycleKeepsRenewal": "Your renewal date stays the same: {{date}}.",
      "crossFullPrice": "{{toPlan}} price for the new term",
      "crossCredit": "Less the unused part of {{fromPlan}}",
      "crossNote": "Changing billing cycle starts a new term, so the renewal date is counted from today — the part of {{fromPlan}} you have not used is not lost, it comes straight off this invoice."
    },
    "discount": {
      "title": "Discount",
      "listLabel": "Plan price",
      "line": "{{name}} discount (−{{pct}}%)"
    }
  },
  "cancelConfirm": {
    "title": "Stop raising the next invoice?",
    "body": "You keep full access to {{plan}} until {{date}}. We will stop raising renewal invoices, and after that date the account moves to the Free plan — your data stays. You can turn it back on any time before then.",
    "confirm": "Stop raising it",
    "back": "No, keep it on"
  },
  "resumeConfirm": {
    "title": "Turn renewal back on?",
    "body": "We will raise a {{plan}} renewal invoice before {{date}} for you to pay, and the plan continues without a gap."
  },
  "prorationHint": "Upgrading mid-cycle only charges the difference for the days left — your renewal date stays the same.",
  "pendingCallout": {
    "title": "Invoice awaiting payment · {{amount}}",
    "body": "Scan the QR and pay before {{date}} to keep {{plan}} running without a gap. If it is still unpaid by then the account moves to the Free plan — your data stays, and you can buy again whenever you like.",
    "bodyNeutral": "Scan the QR and pay before {{date}}.",
    "cta": "Scan QR to pay",
    "cancel": "Cancel invoice",
    "cancelConfirmTitle": "Cancel this invoice?",
    "cancelConfirm": "This upgrade invoice stops being payable. The plan you are on right now does not change — you can choose a plan again any time.",
    "cancelConfirmTerm": "Cancelling the invoice does not cancel your plan: you keep using {{plan}} normally until {{date}}. After that date, with no invoice paid, the account moves to the Free plan — your data stays. You can pay again any time before then.",
    "cancelKeep": "Keep the invoice",
    "cancelError": "Could not cancel the invoice."
  },
  "nudge": {
    "TRIALING": {
      "title": "{{days}} days left in trial",
      "body": "Choose a plan to keep every feature after your trial ends.",
      "cta": "Choose a plan"
    },
    "RENEWAL_DUE": {
      "title": "Renewal due soon",
      "body": "Your {{plan}} plan ends in {{days}} days. Pay to keep it active.",
      "cta": "Pay now"
    },
    "DOWNGRADED": {
      "title": "Your plan moved to Free",
      "body": "Auto-matching bank transfers is paused — your data stays exactly as it is.",
      "cta": "Choose a plan"
    },
    "TRIAL_ENDED": {
      "title": "Your trial has ended",
      "body": "The account moved to the Free plan — your data stays exactly as it is.",
      "cta": "Choose a plan"
    },
    "dismiss": "Hide"
  },
  "offer": {
    "header": "Applying the {{name}} offer: {{pct}}% off the first term, until {{deadline}}.",
    "firstTerm": "First term {{amount}} with {{name}}",
    "chip": "−{{pct}}% first term",
    "countdown": {
      "days": "{{days}}d {{clock}} left",
      "today": "{{clock}} left",
      "trialMerge": "{{trialDays}}d left in trial · offer {{offerCountdown}}"
    },
    "banner": {
      "label": "OFFER",
      "fallback": "{{name}} offer: {{pct}}% off the first term, on every plan",
      "cta": "Upgrade with the offer",
      "dismiss": "Close"
    },
    "haveCode": "Have a promo code?",
    "placeholder": "Enter promo code",
    "apply": "Apply",
    "applied": "Applied code {{code}}: {{pct}}% off the first term.",
    "campaignWins": "The {{name}} offer is discounting more right now, so we applied {{pct}}% instead.",
    "clear": "Remove code",
    "reason": {
      "INVALID": "This code isn't valid. Please double-check it.",
      "EXPIRED": "This code has expired.",
      "NOT_STARTED": "This code isn't active yet.",
      "PLAN": "This code doesn't apply to the plan you picked.",
      "CYCLE": "This code doesn't apply to the billing cycle you picked.",
      "ALREADY_USED": "Your account has already used this code.",
      "CAP": "This code has reached its usage limit.",
      "STATUS": "This offer is only for accounts on a trial or the Free plan."
    }
  }
}
